function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { bool, oneOf, shape, string } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { GEL_SPACING_TRPL, GEL_SPACING_QUAD } from '@bbc/gel-foundations/spacings';
import { C_PEBBLE, C_GHOST, C_SHADOW } from '@bbc/psammead-styles/colours';
import { PlainTitle, LinkTitle } from './titles';
var Bar = /*#__PURE__*/styled.div.withConfig({
  displayName: "Bar",
  componentId: "sc-1x4gwjz-0"
})(["border-top:0.0625rem solid ", ";z-index:-1;@media screen and (-ms-high-contrast:active){border-color:windowText;}@media (min-width:", "){position:absolute;left:0;right:0;top:", "rem;}"], C_PEBBLE, GEL_GROUP_3_SCREEN_WIDTH_MIN, function (_ref) {
  var script = _ref.script;
  return 0.5 + script.doublePica.groupD.lineHeight / 2 / 16;
});
var SectionLabelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SectionLabelWrapper",
  componentId: "sc-1x4gwjz-1"
})(["position:relative;z-index:0;color:", ";margin-top:", ";@media (min-width:", "){margin-top:", ";}@media (min-width:", "){margin-bottom:", ";}", ""], C_SHADOW, GEL_SPACING_QUAD, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_SPACING_TRPL, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING_TRPL, function (_ref2) {
  var visuallyHidden = _ref2.visuallyHidden;
  return visuallyHidden && css(["clip-path:inset(100%);clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute;width:1px;"]);
});
SectionLabelWrapper.propTypes = {
  visuallyHidden: bool.isRequired
};
var Heading = /*#__PURE__*/styled.h2.withConfig({
  displayName: "Heading",
  componentId: "sc-1x4gwjz-2"
})(["margin:0;padding:0;"]);

var SectionLabel = function SectionLabel(_ref3) {
  var bar = _ref3.bar,
      title = _ref3.children,
      dir = _ref3.dir,
      href = _ref3.href,
      labelId = _ref3.labelId,
      linkText = _ref3.linkText,
      script = _ref3.script,
      service = _ref3.service,
      visuallyHidden = _ref3.visuallyHidden,
      backgroundColor = _ref3.backgroundColor,
      props = _objectWithoutProperties(_ref3, ["bar", "children", "dir", "href", "labelId", "linkText", "script", "service", "visuallyHidden", "backgroundColor"]);

  return /*#__PURE__*/React.createElement(SectionLabelWrapper, _extends({
    visuallyHidden: visuallyHidden
  }, props), bar && /*#__PURE__*/React.createElement(Bar, {
    script: script
  }), /*#__PURE__*/React.createElement(Heading, null, linkText && href ? /*#__PURE__*/React.createElement(LinkTitle, {
    dir: dir,
    href: href,
    labelId: labelId,
    linkText: linkText,
    script: script,
    service: service,
    backgroundColor: backgroundColor
  }, title) : /*#__PURE__*/React.createElement(PlainTitle, {
    dir: dir,
    labelId: labelId,
    script: script,
    service: service,
    backgroundColor: backgroundColor
  }, title)));
};

SectionLabel.defaultProps = {
  bar: true,
  dir: 'ltr',
  href: null,
  linkText: null,
  visuallyHidden: false,
  backgroundColor: C_GHOST
};
SectionLabel.propTypes = {
  bar: bool,
  children: string.isRequired,
  dir: oneOf(['ltr', 'rtl']),
  href: string,
  labelId: string.isRequired,
  linkText: string,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  visuallyHidden: bool,
  backgroundColor: string
};
export default SectionLabel;